const ACTION_SCOPE = '[Form]';

export class IncrementStepper {
    static readonly type = `${ACTION_SCOPE} Increment Stepper`;
}

export class DecrementStepper {
    static readonly type = `${ACTION_SCOPE} Decrement Stepper`;
}

export class SetStepper {
    static readonly type = `${ACTION_SCOPE} Set Stepper`;
    constructor(public currentStepIndex: number) {}
}

export class ResetStepper {
    static readonly type = `${ACTION_SCOPE} Reset Stepper`;
}

export class ResetSeasonForm {
    static readonly type = `${ACTION_SCOPE} Reset Form`;
}

export class SubmitForm {
    static readonly type = `${ACTION_SCOPE} Submit Form`;
}
